import { render, staticRenderFns } from "./RegionAddressFields.vue?vue&type=template&id=0a02742c"
import script from "./RegionAddressFields.vue?vue&type=script&lang=js"
export * from "./RegionAddressFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports